import { useContext } from 'react';
import { TerritoryFilterContext } from '../context/territoryFilter';

export function useTerritoryActiveFilter() {
  return useContext(TerritoryFilterContext);
}
